import { render, staticRenderFns } from "./setting.vue?vue&type=template&id=05a32477&scoped=true"
import script from "./setting.vue?vue&type=script&lang=ts"
export * from "./setting.vue?vue&type=script&lang=ts"
import style0 from "./setting.vue?vue&type=style&index=0&id=05a32477&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a32477",
  null
  
)

export default component.exports